module.exports = __webpack_public_path__ + "img/nfc_logo.ab359977.svg";